import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALIDATORS, NG_VALUE_ACCESSOR, UntypedFormBuilder, UntypedFormGroup, ValidationErrors, Validators } from '@angular/forms';
import { AppService, CoreProxyService, CoreTypes, CustomSelectComponent, IncidentTypes, LabelValue, Modal } from 'common-cloudstudio';
import { Subscription } from 'rxjs';
import { IncidentService } from '../../../services/incident.service';

export interface ITS_VehiclesData extends CoreTypes.ITS_VehiclesData, CoreTypes.ITS_IncidentPersons, CoreTypes.ITS_Persons, CoreTypes.ITS_IncidentVehicles { 
  Present?:boolean;
  ModelName?: string;
  VehicleType?: number;
}

export interface ITS_Persons extends CoreTypes.ITS_Persons { 
  PersonType?: number | null;
  OtherPersonType?: string;
}

@Component({
  selector: 'app-incident-vehicles-involved',
  templateUrl: './Incident-vehicles-involved.component.html',
  styleUrls: ['./Incident-vehicles-involved.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => IncidentVehiclesInvolvedComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => IncidentVehiclesInvolvedComponent),
      multi: true,
    }
  ]
})
export class IncidentVehiclesInvolvedComponent implements OnInit, OnDestroy, ControlValueAccessor {
  @ViewChild('search') public searchElementRef: ElementRef;
  today = new Date();
  minDateInsurance = new Date();
  currentYear: number = new Date().getFullYear();

  _data: ITS_VehiclesData = { 
    ...new CoreTypes.ITS_VehiclesData(), 
    ...new CoreTypes.ITS_IncidentPersons(), 
    ...new CoreTypes.ITS_Persons(),
    ...new CoreTypes.ITS_IncidentVehicles()
  };
  @Input('data')
  set data(data: string) {
    this.writeValue(data);
  }
  get data() {
    return JSON.stringify(this._data);
  }
  @Input() editing: boolean = false;
  onChange = (_:any) => { }
  onTouch = () => { }

  @Output() disableForm = new EventEmitter<boolean>();
  _errorMessage = "";
  _parametersClone: ITS_VehiclesData = { 
    ...new CoreTypes.ITS_VehiclesData(), 
    ...new CoreTypes.ITS_IncidentPersons(), 
    ...new CoreTypes.ITS_Persons(),
    ...new CoreTypes.ITS_IncidentVehicles()
  };

  _vehicleMakesList: LabelValue<number>[] = [{label: 'Sin Determinar',value: 0}];
  _vehicleMakesFullList: CoreTypes.ITS_VehicleMakes[] = [];
  _vehicleMakesByIdFullList: CoreTypes.ITS_VehicleMakes[] = [];
  _vehicleModelList: LabelValue<number>[] = [{label: 'Sin Determinar',value: 0}];
  _vehicleModelsFullList: CoreTypes.ITS_VehicleModels[] = [];
  _vehicleModelsByIdFullList: CoreTypes.ITS_VehicleModels[] = [];
  _vehicleTypeList: LabelValue<number>[] = [{label: 'Sin Determinar',value: 0}];
  _vehicleTypesFullList: CoreTypes.ITS_VehicleTypes[] = [];
  _vehicleTypesByIdFullList: CoreTypes.ITS_VehicleTypes[] = [];
  _vehicleColorList: LabelValue<number>[] = [{label: 'Sin Determinar',value: 0}];
  _vehicleColorFullList: CoreTypes.ITS_VehicleColors[] = [];
  _insuranceCompanyList: LabelValue<number>[] = [{label: 'Sin Determinar',value: 0}];
  _assistanceList: LabelValue<number>[] = [];
  _vehiclesDataFullList: CoreTypes.ITS_VehiclesData[] = [];
  _documentTypeList: LabelValue<number>[] = [];
  _personTypeList: LabelValue<number>[] = [];
  _transferResponsibleList: LabelValue<number>[] = [{label: 'Sin Determinar',value: 0}];

  subscriptions: Subscription[] = [];
  isDisabled: boolean;
  documentDisabled: boolean = true;
  searchStatus: number = 0;
  searchStatusBtn: number = 0;
  loadModel:number = 0;
  loadMakes:number = 0;
  form: UntypedFormGroup = this.fb.group({
    licensePlate: ['', ],
    vehicleMakes: [this._vehicleMakesList[0], ],
    vehicleModel: [this._vehicleModelList[0], ],
    vehicleType:[this._vehicleTypeList[0], ],
    vehicleColor: [this._vehicleColorList[0]],
    vehicleYear: [null],
    insuranceCompany:[this._insuranceCompanyList[0], ],
    insurancePolicy:['', ],
    dateFromInsurance: [new CoreTypes.DateTimeDT()],
    dateToInsurance: [new CoreTypes.DateTimeDT()],
    assistance:[this._assistanceList[0], ],
    transfer: [false],
    transferResponsible:[this._transferResponsibleList[0], ],
    documentType: [this._documentTypeList[0] ],
    documentNumber: [null],
    name:['', ],
    lastName:['', ],
    personType: [this._personTypeList[0]],
    // personDescription:[''],
    personPresent: [true],
    vehicleDestination:['', ]
  });

  debounceAction;
  debounceUpdate;
  vehicleDataResult: ITS_VehiclesData = { ...new CoreTypes.ITS_VehiclesData(), ...new CoreTypes.ITS_IncidentVehicles(), ...new CoreTypes.ITS_IncidentPersons(), ...new CoreTypes.ITS_Persons() };
  newInsurance: string = "";
  vehicleOwner: ITS_Persons = new CoreTypes.ITS_Persons();
  firtsTime: boolean = true;
  incidentElementTypes = IncidentTypes.elementTypes;
  vehicleExist: boolean = false;
  disableVehicleForm: boolean = false;
  warningExpiration: boolean = true;

  constructor(
    private fb: UntypedFormBuilder,
    public appService: AppService,
    private coreProxyService: CoreProxyService,
    private incidentService: IncidentService,
    private cdRef:ChangeDetectorRef
  ) { }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  public validate() {
    let errors: ValidationErrors = {};
    Object.keys(this.form.controls).forEach(key => {
      const controlErrors: ValidationErrors = this.form.get(key).errors;
      if (controlErrors != null) {
        errors[key] = controlErrors;
      }
    });
    return errors;
  }

  ngOnInit(): void {
    this.getAssistanceVehicles();
    this.getInsuranceCompanies(this._data);
    this.getAssistance(this._data);
    this.subscriptions.push(this.vehicleColor.valueChanges.subscribe(value => {
      setTimeout(() => {
        if(value?.value) {
          this._data.ColorID = value?.value;
          this.onInput();
        } else if(value?.value == 0 && this._data.ColorID) {
          this._data.ColorID = value?.value;
        }
      }, 100);
    }));
    this.subscriptions.push(this.vehicleYear.valueChanges.subscribe(value => {
      setTimeout(() => {
        if(value) {
          this._data.VehicleYear = value;
          this.onInput();
        }
      }, 100);
    }));
    this.subscriptions.push(this.vehicleMakes.valueChanges.subscribe(value => {
      setTimeout(() => {
        if(value?.value) {
          this._data.VehicleMakeID = value?.value;
          this.onInput();
        }
      }, 100);
    }));

    this.subscriptions.push(this.vehicleModel.valueChanges.subscribe(value => {
      setTimeout(() => {
        if(value?.value) {
          this._data.ModelID = value?.value;
          this.onInput();
        } else if(value && !this._vehicleModelList.length) {
          this._data.ModelName = value;
        }
      }, 100);
    }));

    this.subscriptions.push(this.vehicleType.valueChanges.subscribe(value => {
      setTimeout(() => {
        if(value?.value ! == null || value?.value !== undefined) {
          this._data.VehicleType = value?.value;
          this.onInput();
        }
      }, 100);
    }));

    this.subscriptions.push(this.personPresent.valueChanges.subscribe(value => {
      setTimeout(() => {
        this._data.Present = value;
        if(this.personPresent.value === false) { this._data.PersonTypeID = 0; }
        this.onInput();
      }, 100);
    }));

    this.subscriptions.push(this.insuranceCompany.valueChanges.subscribe(value => {
      setTimeout(() => {
        if(value?.value) {
          this._data.InsuranceCompanyID = value.value;
          this.onInput();
        }
      }, 100);
    }));
    this.subscriptions.push(this.insurancePolicy.valueChanges.subscribe(value => {
      if(value) {
        this._data.InsurancePolicy = value;
        this.onInput();
      }
    }));
    this.subscriptions.push(this.vehicleDestination.valueChanges.subscribe(value => {
      setTimeout(() => {
        if(value) {
          this._data.Destination = value;
          this.onInput();
        }
      }, 100);
    }));

    this.subscriptions.push(this.documentType.valueChanges.subscribe(value => {
      setTimeout(() => {
        if(value?.value) {
          this._data.DocumentTypeID = value.value;
          this.onInput();
        }
      }, 100);
    }));

    this.subscriptions.push(this.documentNumber.valueChanges.subscribe(value => {
      setTimeout(() => {
        this._data.DocumentNumber = value;
        this.onInput();
      }, 100);
    }));

    this.subscriptions.push(this.name.valueChanges.subscribe(value => {
      setTimeout(() => {
        this._data.FirstName = value;
        this.onInput();
      }, 100);
    }));

    this.subscriptions.push(this.lastName.valueChanges.subscribe(value => {
      setTimeout(() => {
        if(value) {
          this._data.LastName = value;
          this.onInput();
        }
      }, 100);
    }));

    this.subscriptions.push(this.personType.valueChanges.subscribe(value => {
      setTimeout(() => {
        if(value?.value) {
          this._data.PersonTypeID = value?.value;
          this.onInput();
        }
      }, 100);
    }));

    // this.subscriptions.push(this.personDescription.valueChanges.subscribe(value => {
    //   setTimeout(() => {
    //     this._data.OtherPersonType = value;
    //     this.onInput();
    //   }, 10);
    // }));
    this.subscriptions.push(this.assistance.valueChanges.subscribe(value => {
      if(value?.value) {
        this._data.AssistanceType = value.value; 
      }
      this.onInput();
    }));

    this.subscriptions.push(this.transfer.valueChanges.subscribe(value => {
      value ? this.vehicleDestination.enable() : this.vehicleDestination.disable();
      setTimeout(() => {
        this._data.Transferred = value;
        if(this.transfer.value === false) {
          this.transferResponsible.setValue(this._transferResponsibleList[0]);
          this._data.TransferredBy = 0;
          this.vehicleDestination.setValue("");
          this._data.Destination = "";
        }
        this.onInput();
      }, 100);
    }));

    this.subscriptions.push(this.transferResponsible.valueChanges.subscribe(value => {
      setTimeout(() => {
        if((value?.value || value.value == 0) && this.transfer.value) {
          this._data.TransferredBy = value.value;
        }
        this.onInput();
      }, 100);
    }));
  }
  
  ngOnDestroy() {
    clearTimeout(this.debounceAction);
    clearTimeout(this.debounceUpdate);
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  onInput() {
    if(!this._data.LicensePlate || (!this._data.ModelID && !this._data?.ModelName) || !this._data?.VehicleType || (this.vehicleExist && this.disableVehicleForm) ) {
      this.disableForm.emit(true);
    } else{
      this.disableForm.emit(false);
    }
    this.onTouch();
    this.onChange(this._data);
  }

  writeValue(value: any): void {
    this.firtsTime = true;
    if(this.editing) this.loadModel = 1;
    
    if (value) {
      (typeof value === "object") ? this._data = value : this._data = JSON?.parse(value);
      this.licensePlate.setValue(this._data.LicensePlate);
      if(this._data.DocumentTypeID) this.onLoadPerson(this._data);
      const makesValue = this._data.VehicleMakeID
      ? this._vehicleMakesList.find(m => m.value === this._data.VehicleMakeID)
      : this._vehicleMakesList[0];
      this.vehicleMakes.setValue(makesValue);
      const modelValue = this._data.ModelID 
      ? this._vehicleModelList.find(x => x.value === this._data.ModelID)
      : this._vehicleModelList[0];
      this.vehicleModel.setValue(modelValue);
      this.cdRef.detectChanges();

      const vehicleType = this._data.ModelID ? this._vehicleModelsFullList.find(x => x.ModelID === this._data.ModelID)?.VehicleType : null;
      const typeValue = vehicleType ? this._vehicleTypeList.find(t => t.value === vehicleType.TypeID) : this._vehicleTypeList[0]
      this.vehicleType.setValue(typeValue);

      const colorValue = this._data.ColorID 
      ? this._vehicleColorList.find(x => x.value === this._data.ColorID)
      : this._vehicleColorList[0];
      this.vehicleColor.setValue(colorValue);
      const insurance = this._data.InsuranceCompanyID
      ? this._insuranceCompanyList.find(x => x.value === this._data.InsuranceCompanyID)
      : this._insuranceCompanyList[0];
      this.insuranceCompany.setValue(insurance);
      // this.personDescription.setValue(this._data.OtherPersonType);
      this.vehicleYear.setValue(this._data?.VehicleYear);
      this.insurancePolicy.setValue(this._data.InsurancePolicy);
      this.vehicleDestination.setValue(this._data.Destination);
      this.dateFromInsurance.setValue(this._data.InsurancePolicyEffectiveSince);
      this.dateToInsurance.setValue(this._data.InsurancePolicyValidUntil);
      this.personPresent.setValue(this._data.Present);
      this.documentNumber.setValue(this._data.DocumentNumber);
      this.name.setValue(this._data.FirstName);
      this.lastName.setValue(this._data.LastName);
    } else {
      this._data = { 
        ...new CoreTypes.ITS_VehiclesData(), 
        ...new CoreTypes.ITS_IncidentPersons(), 
        ...new CoreTypes.ITS_Persons(),
        ...new CoreTypes.ITS_IncidentVehicles()
      };
      this.onLoadPerson(this._data);
      this.personPresent.setValue(true);
    }
    this._data?.TransferredBy || this._data?.Destination ? this.transfer.setValue(true) : this.transfer.setValue(false);
    this.transfer.value ? this.vehicleDestination.enable() : this.vehicleDestination.disable();
    let assistence = this._assistanceList.find(a => a.value === this._data?.AssistanceType)?? this._assistanceList[0];
    this.assistance.setValue(assistence);

    let transferResponsible = this._transferResponsibleList.find(t => t.value === this._data?.TransferredBy) ?? this._transferResponsibleList[0];
    this.transferResponsible.setValue(transferResponsible);
    this._parametersClone = JSON.parse(JSON.stringify(this._data));
    this.onInput();
  }
  
  licenseChange() {
    if(!this.licensePlate?.value?.length) {
      this._errorMessage = "";
      this.resetForm(); 
    }
    clearTimeout(this.debounceAction);
    this.debounceAction = setTimeout(() => {
      if (this.licensePlate.value && this.licensePlate.value.length > 4) { this.onLicenseSearch(this.licensePlate.value); }
    }, 300);
    this.vehicleExist = this.licenseExist(this.licensePlate?.value);
  }

  licenseExist(item: any): boolean {
    return this.incidentService.isItemSelectedInSection(this.incidentElementTypes.InvolvedVehicles, item);
  }

  onLicenseSearch(license, useExternal?) {
    this._errorMessage = "";
    this.loadModel = 1;
    this.warningExpiration = true;
    if(this.licensePlate.value === this._data.LicensePlate && this._data?.ModelID && this.editing) {
      this.onLoadData(this._data);
      this.onLoadPerson(this._data);
      this._data.VehicleMakeID ? this.getModelsByMakeID(this._data.VehicleMakeID, this._data) : this.getVehicleModels(this._data);
      this.documentNumber.value && this._data.VehicleOwnerID ? this.disabledPersonData(): this.enabledPersonData();
      return; 
    }
    this.searchStatus = 1;
    if(useExternal) this.searchStatusBtn = 1;
    this.coreProxyService.IncidentService.SearchITSVehicleRegistration(
      this.appService.getAccessToken(),
      this.appService.getFacilityID(),
      license,
      useExternal,
      async success => {
        this.vehicleOwner = new CoreTypes.ITS_Persons();
        this.vehicleDataResult = JSON.parse(JSON.stringify(success));
        if(!success.LicensePlate) {  
          this.vehicleDataResult.LicensePlate = license;
          this._data.LicensePlate = license;
        }

        if(success.VehicleOwnerID) {
          this.incidentService.getITSPerson(success.VehicleOwnerID).then(vehicle => {
            this.vehicleOwner = vehicle;
            this.documentNumber.setValue(this.vehicleOwner.DocumentNumber);
            this.name.setValue(this.vehicleOwner.FirstName);
            this.lastName.setValue(this.vehicleOwner.LastName);
            this._data.DocumentTypeID = this.vehicleOwner.DocumentTypeID;
            this._data.DocumentNumber = this.vehicleOwner.DocumentNumber;
            this.personPresent.setValue(true);
            this.loadVehicleFullData(success?.LicensePlate, success?.VehicleMakeID);
            this.disabledPersonData();
          }).catch(() => {
            this.searchStatus = 2;
            this.searchStatusBtn = 2;
            this.enabledPersonData();
            this.loadVehicleFullData(success?.LicensePlate, success?.VehicleMakeID);
          });
        } else {
          this.enabledPersonData();
          this.loadVehicleFullData(success?.LicensePlate, success?.VehicleMakeID);
        }
        this.searchStatus = 0;
        setTimeout(() => this.searchStatusBtn = 0, 100);

        if(success.InsurancePolicyEffectiveSince?.Date?.Day || success.InsurancePolicyValidUntil?.Date?.Day){
          this.warningExpiration = success.InsuranceIsValid;
        }

        if(this.vehicleExist && this._parametersClone?.LicensePlate !== this.licensePlate.value) {
          this._errorMessage = "Este vehículo ya ha sido agregado. No se permiten duplicados";
          this.disableVehicleForm = true;
        } else {
          this._errorMessage = "";
          this.disableVehicleForm = false;
        }
        if(!success.LicensePlate) {
          this._errorMessage = 'Patente no encontrada';
          this.loadModel = 0;
          this.incidentService._vehicleModelsFullList.value.length = 0;
          this.incidentService._vehicleModelsStatus = 0;
          this._vehicleModelsFullList = [];
          this._vehicleModelList = [{label: 'Sin Determinar',value: 0}];
          this.getVehicleMakes(success);
          this.setDisabledState(false);
          this.resetForm();
          return;
        }
        this.setDisabledState(true);
      },
      err => {
        this._errorMessage = err.Message;
        this.searchStatus = 2;
        this.searchStatusBtn = 2;
        this.loadModel = 2;
        this.cleanForm();
        this.appService.showException(err);
      }
    )
  }

  loadVehicleFullData(licensePlate: string, vehicleMakeID: number ) {
    this.vehicleDataResult.Present = this.personPresent.value;
    this.vehicleDataResult.ContactAddress = this.vehicleOwner.ContactAddress;
    this.vehicleDataResult.ContactPhone = this.vehicleOwner.ContactPhone;
    this.vehicleDataResult.CountryID = this.vehicleOwner.CountryID?this.vehicleOwner.CountryID: this._data.CountryID;
    this.vehicleDataResult.DocumentNumber = this.vehicleOwner.DocumentNumber ? this.vehicleOwner.DocumentNumber : this._data.DocumentNumber;
    this.vehicleDataResult.DocumentTypeID = this.vehicleOwner.DocumentTypeID ? this.vehicleOwner.DocumentTypeID : this._data.DocumentTypeID ? this._data.DocumentTypeID : this.documentType?.value?.value;
    this.vehicleDataResult.FirstName = this.vehicleOwner.FirstName ? this.vehicleOwner.FirstName: this._data.FirstName;
    this.vehicleDataResult.GenderID = this.vehicleOwner.GenderID;
    this.vehicleDataResult.HasEmptyInformation = this.vehicleOwner.HasEmptyInformation;
    this.vehicleDataResult.LastName = this.vehicleOwner.LastName ?this.vehicleOwner.LastName: this._data.LastName;
    this.vehicleDataResult.NeedConfirmName = this.vehicleOwner.NeedConfirmName;
    this.vehicleDataResult.NeedToBeUpdated = this.vehicleOwner.NeedToBeUpdated;
    this.vehicleDataResult.PersonID = this.vehicleOwner.PersonID;
    this.vehicleDataResult.PersonTypeID = this._data.PersonTypeID;
    this.vehicleDataResult.Destination = this._data.Destination;
    // this.vehicleDataResult.OtherPersonType = this._data.OtherPersonType;
    this.vehicleDataResult.DamageResponsibilityID = this._data.DamageResponsibilityID;
    this.vehicleDataResult.HealthConditionID = this._data.HealthConditionID;
    this.vehicleDataResult.HospitalID = this._data.HospitalID;
    this.vehicleDataResult.IncidentID = this._data.IncidentID;
    this.vehicleDataResult.AssistanceType = this._data?.AssistanceType ? this._data?.AssistanceType : this.assistance?.value?.value;
    this.vehicleDataResult.VehicleYear = this._data.VehicleYear;
    this.vehicleDataResult.Transferred = this._data.Transferred;
    this.vehicleDataResult.TransferredBy = this._data.TransferredBy;
    this.onLoadData(this.vehicleDataResult);
    this.onLoadPerson(this.vehicleDataResult);
    if(licensePlate && vehicleMakeID) {
      this.getModelsByMakeID(vehicleMakeID, this.vehicleDataResult);
    }

  }

  disabledPersonData() {
    this.documentDisabled = true;
    this.name.disable();
    this.lastName.disable();
    this.documentType.disable();
    this.documentNumber.disable();
  }

  enabledPersonData() {
    this.documentDisabled = false;
    this.name.enable();
    this.lastName.enable();
    this.documentType.enable();
    this.documentNumber.enable();
  }

  onLoadData(data) {
    this.getVehicleMakes(data);
    this.getVehicleColors(data);
    this.getInsuranceCompanies(data);
    this.getAssistance(data);
    this.getAssistanceVehicles();
  }

  onLoadPerson(data) {
    this.getDocumentTypes(data);
    this.getPersonTypes(data);
  }

  async getVehicleModels(vehicleDataResult:ITS_VehiclesData) {
    if(this._vehicleMakesFullList.length && this.vehicleMakes?.value?.value) {
      let makeList = this._vehicleMakesFullList.map(make => {
        return make.MakeID;
      })
      this._vehicleModelsFullList = await this.incidentService.getITSVehicleModels(makeList);
    } else {
      this._vehicleModelsFullList = await this.incidentService.getVehicleModels();
    }
    this._vehicleModelList = await this.incidentService._vehicleModelsList.value;
    let vehicleModel = this._vehicleModelList.find(v => v.value === vehicleDataResult.ModelID)??this._vehicleModelList[0];
    this.vehicleModel.setValue(vehicleModel);
    this.cdRef.detectChanges();
    this.setVehicleModelData(vehicleDataResult);
  }

  getModelsByMakeID(makeId, vehicleDataResult) {
    this.loadModel = 1;
    this._vehicleModelsFullList  = [];
    this.incidentService._vehicleModelsFullList.value.length = 0;
    this.coreProxyService.IncidentService.EnumITSVehicleModelsByMakeID(
      this.appService.getAccessToken(),
      this.appService.getFacilityID(),
      makeId,
      data => {
        this._vehicleModelsByIdFullList = data;
        this._vehicleModelsFullList = data;
        this.incidentService._vehicleModelsFullList.next(data);
        let optionsList: LabelValue<number>[] = [];
        optionsList.push({ label: 'Sin Determinar', value: 0 });
        data.forEach((x) => {
          let item = { label: x.ModelDisplay, value: x.ModelID };
          optionsList.push(item);
        });
        this._vehicleModelList = optionsList;
        let vehicleModel = this._vehicleModelList.find(v => v.value === vehicleDataResult.ModelID)??this._vehicleModelList[0];
        this.vehicleModel.setValue(vehicleModel);
        this.cdRef.detectChanges();
        this.setVehicleModelData(vehicleDataResult);
        // this.loadModel = 0;
      },
      async err => {
        this.loadModel = 2;
        this.appService.showException(err);
        this.setVehicleModelData(vehicleDataResult);
        this.getVehicleModels(vehicleDataResult);
      }
    );
  }

  setVehicleModelData(vehicleData) {
    this._vehicleModelsFullList.length ? this.getVehiclesTypes(vehicleData) : this.getVehicleTypesList();
    this.loadModel = 0;
    this._data = vehicleData;
    this.onInput();
  }

  async getVehicleMakes(vehicleDataResult) {
    this.loadMakes = 1;
    this._vehicleMakesList = [];
    this.incidentService.getVehicleMakes().then(async makeList => {
      this.loadMakes = 0;
      this._vehicleMakesFullList = makeList;
      this._vehicleMakesList = await this.incidentService._vehicleMakesList.value;
      let vehicleMakes = this._vehicleMakesList.find(v => v.value === vehicleDataResult.VehicleMakeID)??this._vehicleMakesList[0];
      this.vehicleMakes.setValue(vehicleMakes);
      this.cdRef.detectChanges();
    }).catch(() => { this.loadMakes = 2; }) ;
  }

  async getVehicleColors(vehicleDataResult) {
    this._vehicleColorFullList = await this.incidentService.getVehicleColor();
    this._vehicleColorList = await this.incidentService._vehicleColorList.value;
    let vehicleColor = this._vehicleColorList.find(v => v.value === vehicleDataResult.ColorID)??this._vehicleColorList[0];
    this.vehicleColor.setValue(vehicleColor);
  }

  async getVehiclesTypes(vehicleDataResult) {
    if(!vehicleDataResult.ModelID && !this.vehicleModel?.value?.value) { return; }
    this.coreProxyService.IncidentService.EnumITSVehicleTypeByModelID(
      this.appService.getAccessToken(),
      this.appService.getFacilityID(),
      this.vehicleModel.value.value ? this.vehicleModel.value.value : vehicleDataResult.ModelID,
      data => {
        let optionsList: LabelValue<number>[] = [];
        if(data.length) {
          optionsList.push({ label: 'Sin Determinar', value: 0 });
        }
        data.forEach((x) => {
          let item = { label: x.TypeName, value: x.TypeID };
          optionsList.push(item);
        });
        this._vehicleTypeList = optionsList;
        this.onSelectModel();
      },
      async err => {
        this.appService.showException(err);
        this.getVehicleTypesList();
      }
    );
  }

  async getVehicleTypesList() {
    this._vehicleTypesFullList = await this.incidentService.getVehicleTypes();
    this._vehicleTypeList = await this.incidentService._vehicleTypesList.value;
    await this.onSelectModel();
  }

  async getVehiclesData() {
    this._vehiclesDataFullList = await this.incidentService.getVehiclesData();
    this._vehicleTypeList = await this.incidentService._vehicleTypesList.value;
  }
   
  async getAssistance(data) {
    await this.incidentService.getVehicleAssistanceReasons();
    this._assistanceList = this.incidentService._assistenceReasonList.value;
    let assistance = this._assistanceList.find(v => v.value === data?.AssistanceType)??this._assistanceList[0];
    this.assistance.setValue(assistance);
  }

  async getInsuranceCompanies(vehicleDataResult: ITS_VehiclesData, insuranceCompanyID?:number) {
    let insuranceCom, insuranceID, insurance;
    insurance = await this.incidentService.getITSInsuranceCompanies();
    this._insuranceCompanyList = this.incidentService._insuranceCompaniesList.value;
    insuranceCompanyID ? insuranceID = insuranceCompanyID : insuranceID = vehicleDataResult.InsuranceCompanyID;
    insuranceCom = this._insuranceCompanyList.find(v => v.value === insuranceID)??this._insuranceCompanyList[0];
    this.insuranceCompany.setValue(insuranceCom);
  }

  onSelectModel() {
    let vehicleTypeID = this._vehicleModelsFullList.find(x => x.ModelID === this.vehicleModel?.value?.value)?.VehicleType.TypeID;
    let vehicleType = this._vehicleTypeList.find(v => v.value === vehicleTypeID)??this._vehicleTypeList[0];
    this.vehicleType.setValue(vehicleType);
  }

  onClickclearText() {
    this.licensePlate.setValue("");
    this._errorMessage = "";
    this.resetForm();
    this.searchElementRef?.nativeElement?.focus();
    this._data = { 
      ...new CoreTypes.ITS_VehiclesData(), 
      ...new CoreTypes.ITS_IncidentPersons(), 
      ...new CoreTypes.ITS_Persons(),
      ...new CoreTypes.ITS_IncidentVehicles()
    };
  }

  cleanForm() {
    this._vehicleModelList = [];
    this._vehicleColorList = [];
    this._vehicleMakesList = [];
    this._vehicleTypeList = [];
    this.vehicleModel.setValue(new LabelValue());
    this.vehicleColor.setValue(new LabelValue());
    this.vehicleType.setValue(new LabelValue());
    this.insurancePolicy.setValue("");
    this.vehicleDestination.setValue("");
    this.documentNumber.setValue("");
    this.name.setValue("");
    this.lastName.setValue("");
    this.vehicleYear.setValue("");
    this._errorMessage = "";
  }

  resetForm() {
    this.vehicleModel.setValue(this._vehicleModelList[0]);
    this.vehicleMakes.setValue(this._vehicleMakesList[0])
    this.documentType.setValue(this._documentTypeList[0]);
    this.vehicleColor.setValue(this._vehicleColorList[0]);
    this.vehicleType.setValue(this._vehicleTypeList[0]);
    this.personType.setValue(this._personTypeList[2]);
    this.assistance.setValue(this._assistanceList[0]);
    this.vehicleYear.setValue('');
    this.dateFromInsurance?.setValue(null);
    this.dateToInsurance?.setValue(null);
    this.transfer.setValue(false);
    this.transferResponsible.setValue(this._transferResponsibleList[0]);
    this.insuranceCompany.setValue(this._insuranceCompanyList[0]);
    this.insurancePolicy.setValue("");
    this.vehicleDestination.setValue("");
    this.documentNumber.setValue("");
    this.name.setValue("");
    this.lastName.setValue("");
    // this.personDescription.setValue("");
    this.vehicleExist = null;
    this.disableVehicleForm = false;
    this.warningExpiration = true;
    this.disableForm.emit(false);
  }

  async saveInsurance(insuranceName) {
    let insurance = await this.incidentService.createInsuranceCompany(insuranceName);    
    setTimeout(() => {
      this.getInsuranceCompanies(this._data, insurance.InsuranceCompanyID);
    }, 200);
  }
  
  async getDocumentTypes(data) {
    let documents = await this.incidentService.getDocumentTypes();
    this._documentTypeList = this.incidentService._documentTypeList.value;
    let documentType = this._documentTypeList.find(v => v.value === data.DocumentTypeID)??this._documentTypeList[0];
    this.documentType.setValue(documentType);
  }
  
  async getPersonTypes(data) {
    let personTypesList = await this.incidentService.getPersonTypes();
    this._personTypeList = JSON.parse(JSON.stringify(this.incidentService._personTypeList.value));
    let personType = this._personTypeList.find(v => v.value === data.PersonType)??this._personTypeList[2];
    this.personType.setValue(personType);
  }  
  
  onDateChange(controlName) {
    if((controlName === "dateFromInsurance" || controlName === "dateToInsurance") && this.dateFromInsurance.value?.Date?.Day) {
      this.minDateInsurance = this.incidentService.setMinDate(this.dateFromInsurance.value);
    }
    if(controlName === "dateFromInsurance") { this._data.InsurancePolicyEffectiveSince = this.dateFromInsurance.value; }
    if(controlName === "dateToInsurance") { this._data.InsurancePolicyValidUntil = this.dateToInsurance.value; }
  }

  updateVehicleColor() {
    if(!this.vehicleColor?.value?.value || !this._data.VehicleDataID) return;
    this.coreProxyService.IncidentService.UpdateITSVehicleDataColor(
     this.appService.getAccessToken(),
     this.appService.getFacilityID(),
     this._data.VehicleDataID,
     this.vehicleColor.value.value,
     data => { },
     err => {
      this.appService.showException(err);
     }
    )
  }

  updatePersonFullName(firstName, lastName) {
    if(this.editing && this.firtsTime) {
      this.firtsTime = false;
      return;
    }
    if(this._data.VehicleOwnerID && firstName && lastName && this._data.FirstName && (firstName !== this._data.FirstName || (lastName !== this._data.LastName))) {
      clearTimeout(this.debounceUpdate);
      this.debounceUpdate = setTimeout(() => {
        if(!this._data.PersonID) return;
        this.incidentService.updatePersonFullName(this._data.PersonID, firstName, lastName).then(data => {
          this._data.FirstName = data.FirstName;
          this._data.LastName = data.LastName;
        });
      },300)
    }
  }

  getAssistanceVehicles() {
    this._transferResponsibleList = [];
    let optionsList: LabelValue<number>[] = [];
    optionsList.push({ label: 'Sin Determinar', value: 0 });
    this.incidentService._assistanceDispacthList?.forEach(x => {
      let item = { label: x.Movil, value: x.VehicleID ? x.VehicleID : x.ServiceID };
      optionsList.push(item);
    });
    this._transferResponsibleList = optionsList;
  }
  
  get licensePlate() { return this.form.get('licensePlate'); }
  get vehicleMakes() { return this.form.get('vehicleMakes'); }
  get vehicleModel() { return this.form.get('vehicleModel'); }
  get vehicleType() { return this.form.get('vehicleType'); }
  get vehicleColor() { return this.form.get('vehicleColor'); }
  get vehicleYear() { return this.form.get('vehicleYear'); }
  get insuranceCompany() { return this.form.get('insuranceCompany'); }
  get insurancePolicy() { return this.form.get('insurancePolicy'); }
  get dateFromInsurance() { return this.form.get('dateFromInsurance'); }
  get dateToInsurance() { return this.form.get('dateToInsurance'); }
  get assistance() { return this.form.get('assistance'); }
  get transfer() { return this.form.get('transfer'); }
  get transferResponsible() { return this.form.get('transferResponsible'); }
  get documentType() { return this.form.get('documentType'); }
  get documentNumber() { return this.form.get('documentNumber'); }
  get name() { return this.form.get('name'); }
  get lastName() { return this.form.get('lastName'); }
  get personType() { return this.form.get('personType'); } 
  // get personDescription() { return this.form.get('personDescription'); } 
  get personPresent() { return this.form.get('personPresent'); }
  get vehicleDestination() { return this.form.get('vehicleDestination'); }

}
